import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCart } from 'lucide-react';
const buyers = [{
  name: 'Martín',
  city: 'Buenos Aires'
}, {
  name: 'Lucas',
  city: 'Córdoba'
}, {
  name: 'Diego',
  city: 'Mendoza'
}, {
  name: 'Franco',
  city: 'Rosario'
}, {
  name: 'Sebastián',
  city: 'Tucumán'
}, {
  name: 'Nicolás',
  city: 'Santa Fe'
}, {
  name: 'Alejandro',
  city: 'La Plata'
}, {
  name: 'Matías',
  city: 'Mar del Plata'
}, {
  name: 'Gonzalo',
  city: 'Salta'
}, {
  name: 'Pablo',
  city: 'Neuquén'
}, {
  name: 'Ramiro',
  city: 'San Juan'
}, {
  name: 'Facundo',
  city: 'Bahía Blanca'
}];
function getRandomBuyer() {
  return buyers[Math.floor(Math.random() * buyers.length)];
}
function getRandomMinutes() {
  return Math.floor(Math.random() * 15) + 1;
}
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  const [buyer, setBuyer] = useState(getRandomBuyer());
  const [minutes, setMinutes] = useState(getRandomMinutes());
  useEffect(() => {
    const showNotification = () => {
      setBuyer(getRandomBuyer());
      setMinutes(getRandomMinutes());
      setVisible(true);
      setTimeout(() => setVisible(false), 4000);
    };
    const initialTimeout = setTimeout(showNotification, 8000);
    const interval = setInterval(showNotification, 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-185">
      {visible && <motion.div initial={{
      opacity: 0,
      x: -100,
      y: 0
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -100
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-6 left-6 z-50 bg-gray-900 border border-motor-red/50 rounded-lg shadow-red-glow p-4 flex items-center gap-4 max-w-sm" data-id="element-186">
          <div className="w-12 h-12 bg-motor-red/20 rounded-full flex items-center justify-center flex-shrink-0 border border-motor-red/50" data-id="element-187">
            <ShoppingCart className="w-6 h-6 text-motor-red" data-id="element-188" />
          </div>
          <div data-id="element-189">
            <p className="text-white font-montserrat text-sm font-semibold" data-id="element-190">
              {buyer.name} de {buyer.city}
            </p>
            <p className="text-gray-400 font-montserrat text-xs" data-id="element-191">
              Compró{' '}
              <span className="text-motor-red font-semibold" data-id="element-192">Motor 2T Pro</span>{' '}
              hace {minutes} min
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}